import template from './negotiated-rate.html';
import './negotiated-rate.scss';

const DIRECTIVE_NAME = NegotiatedRate.DIRECTIVE_NAME = 'ktNegotiatedRate';
export default function NegotiatedRate() {
    return {
        restrict: 'A',
        scope: {
            hotel: `=${DIRECTIVE_NAME}`,
        },
        controller: NegotiatedRateController,
        controllerAs: 'negotiatedRateCtrl',
        template,
        bindToController: true,
    };
}

export function NegotiatedRateController() {
    const vm = this;

    Object.assign(vm, {
        hasCustomerNegotiatedRates,
        hasNegotiatedRatesOrIsKtPreferred,
    });

    function hasCustomerNegotiatedRates() {
        return vm.hotel && !!vm.hotel.HasCustomerSpecificRates;
    }

    function hasNegotiatedRatesOrIsKtPreferred() {
        const {HasNegotiatedRates, IsKTPreferred, HasCustomerSpecificRates} = vm.hotel;
        return !HasCustomerSpecificRates && !!(HasNegotiatedRates || IsKTPreferred);
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/negotiated-rate/negotiated-rate-component.js